import CardsContainer from "./cards-container";
import { ExperiencesFilterOptions } from "./experiences-filters";
import FiltersBar from "./filters-bar";
import { useRouter } from "next/router";
import FiltersBarSearch from "./filters-bar-search";

export default function TabSearch({
  children,
  text,
  count,
  selectedFilters,
  onFiltersChange,
}: {
  children: React.ReactNode;
  text: string;
  count: number;
  selectedFilters?: ExperiencesFilterOptions;
  onFiltersChange?: (filters: ExperiencesFilterOptions) => void;
}) {
  const isInMap = useRouter().pathname.endsWith("map");
  return (
    <>
      <FiltersBarSearch
        text={text}
        count={count}
        selectedFilters={selectedFilters}
        onFiltersChange={onFiltersChange}
      />
      <div className="flex justify-center items-center w-full h-full">
        {isInMap ? (
          <div className="w-full h-full">{children}</div>
        ) : (
          <CardsContainer>{children}</CardsContainer>
        )}
      </div>
    </>
  );
}
